import { Component, OnInit } from '@angular/core';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-vivawallet-error',
  templateUrl: './vivawallet-error.component.html',
  styleUrls: ['./vivawallet-error.component.css']
})
export class VivawalletErrorComponent implements OnInit {

  constructor(
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = false;
   }

  ngOnInit(): void {
    window.location.href = this.getRedirectUrl();
  }

  getRedirectUrl() {
    return "https://languesvivantes.com/fr/reserver-maintenant/erreur-de-paiement/";
  }

}
